import * as React from 'react'
import {observer} from 'mobx-react'
import {makeAutoObservable} from 'mobx'
import {Button} from 'devextreme-react/button'
import styles from "./ConfirmationDialog.module.scss";
import {useContext} from "react";
import {AppStoreContext} from "../../Stores/AppStore";
import DateTimeService from "../../Services/DateTimeService";

type ConfirmationDialogProps = {
    key: string;
    title: string;
    resolve: (value: unknown) => void;
    message: string | JSX.Element;
    onConfirm?: () => void | Promise<void>;
};

export const ConfirmationDialog = observer(() => {
    const context = useContext(AppStoreContext);

    const _onCancelClick = (key: string) => () => {
        context.confirmationStore.closeDialog(key)
    }
    return (
        <>
            {context.confirmationStore.modals.map(modal => {
                return (
                    <div className={styles.wrapper} key={modal.key}>
                        <div className={styles.dialog}>
                            <div className={styles.header}>{modal.title}</div>
                            <div className={styles.content}>{modal.message}</div>
                            <div className={styles.footer}>
                                <Button text="Cancel" onClick={_onCancelClick(modal.key)} stylingMode="outlined"/>
                                <Button text="Confirm" type="default" onClick={context.confirmationStore.confirmDialog(modal.key)}/>
                            </div>
                        </div>
                    </div>
                )
            })}
        </>
    )
})

export class ConfirmationStore {
    public modals: ConfirmationDialogProps[] = []

    constructor() {
        makeAutoObservable(this)
    }

    public showConfirmation(message: string | JSX.Element, title: string) {
        return new Promise(resolve => {
            this.modals.push({message, title, key: `${DateTimeService.now().getTime()}`, resolve})
        })
    }

    public confirmDialog = (key?: string) => () => {
        if (this.modals.length) {
            let index = this.modals.findIndex(e => e.key === key)
            if (index === -1) {
                index = this.modals.length - 1
            }
            this.modals[index].resolve(true)
            this.closeDialog(this.modals[index].key)
        }
    }

    public closeDialog(key?: string) {
        if (this.modals.length) {
            let removeLast = true
            this.modals = this.modals.filter(e => {
                const isCurrent = e.key !== key
                if (isCurrent) removeLast = false
                return isCurrent
            })
            if (removeLast) {
                this.modals.pop()
            }
        }
    }
}